/**
 * =============================================================================
 * size-chart-socks.js 
 * =============================================================================
 * =============================================================================
 */

 var SizeChartSocks = {
  data: {
    selectors: {
      container: ".mp-size-chart-socks",
      angle_size: "[data-mp-size-chart-socks-ankle]",
      unit_switch_button: "[data-mp-size-chart-unit]",
      unit_switch_attribute: "data-mp-size-chart-unit"
    },
    active: "cm",
    sizes: {
      cm: {
        ankle: {
          floor: 19,
          ceil: 26.5,
          small_max: 21.5,
          medium_max: 24
        },
        calf: {
          floor: 28,
          ceil: 46,
          small_max: 38,
          medium_min: 33,
          medium_max: 43.5,
          large_min: 35.5
        }
      },
      inch: {
        ankle: {
          floor: 7,
          ceil: 11,
          small_max: 8.5,
          medium_max: 9.5
        },
        calf: {
          floor: 11,
          ceil: 18,
          small_max: 15,
          medium_min: 13,
          medium_max: 17,
          large_min: 14
        }
      }
    } 
  },

  onReady: function(){
    if(!MP.Utilities.isProductPage() || !this.hasSizeChart()){
    //  return;
    }

    var that = this;

    $(document).on('input', '.form-range', this.handleMeasurementUpdate.bind(this));

    //$("button", this.data.selectors.container).on("click", this.handleUnitUpdate.bind(this));

    //$("[data-rangeslider][data-mp-unit='"+this.data.active+"']").trigger("input");
  },

  // handleUnitUpdate: function(e) {
  //   // Update button state
  //   // $("button", this.data.selectors.container).removeClass("uk-button-primary").addClass("uk-button-default");
  //   // $(e.target).removeClass("uk-button-default").addClass("uk-button-primary");
  //   var previous = this.data.active;
  //   this.data.active = $(e.target).attr(this.data.selectors.unit_switch_attribute);

  //   // // Update visible panel
  //   // $("div[data-mp-size-chart-unit='"+previous+"']").addClass("uk-hidden");
  //   // $("div[data-mp-size-chart-unit='"+this.data.active+"']").removeClass("uk-hidden");
  //   // $("[data-rangeslider][data-mp-unit='"+this.data.active+"']").trigger("input");
  // },

  handleMeasurementUpdate: function(e) {
    console.log('handling measurement update');
    // Set appropriate slider value
    var element = e.target;
    var unit = $(element).attr("data-mp-unit");
    var part = $(element).attr("data-mp-part");
    var value = element.value; // .replace('.25', '&frac14;').replace('.5', '&frac12;').replace('.75', '&frac34;');
    // $("[data-mp-size-chart-unit='"+unit+"'] [data-mp-size-chart-socks-"+part+"]").html(value);
    console.log(unit, value, part);

    // Do the maths
    var possibleSizes = [];
    var unitSizes = this.data.sizes[unit];
    this.data.active = $(".tab-pane.show").attr("data-mp-size-chart-unit");
    console.log('active?', this.data.active);
    var ankle = parseFloat($("[data-mp-unit='"+ this.data.active +"'][data-mp-part='ankle']").val());
    var calf = parseFloat($("[data-mp-unit='"+ this.data.active +"'][data-mp-part='calf']").val());
    console.log('ankle: ',ankle,'calf: ',calf);
    if (ankle >= unitSizes.ankle.floor && ankle <= unitSizes.ankle.small_max && (calf >= unitSizes.calf.floor && calf <= unitSizes.calf.small_max)) {
      possibleSizes.push(1);
    }
    if (ankle >= unitSizes.ankle.small_max && ankle <= unitSizes.ankle.medium_max && (calf >= unitSizes.calf.medium_min && calf <= unitSizes.calf.medium_max)) {
      possibleSizes.push(2);
    }
    if (ankle >= unitSizes.ankle.medium_max && ankle <= unitSizes.ankle.ceil && (calf >= unitSizes.calf.large_min && calf <= unitSizes.calf.ceil)) {
      possibleSizes.push(3);
    }
    if(possibleSizes.length > 0){
      possibleSizes = Math.max.apply(Math, possibleSizes);
    } else {
      possibleSizes = 0
    }

    $("[data-mp-size-chart-result]").addClass("d-none");
    $("[data-mp-size-chart-result='"+possibleSizes+"']").removeClass("d-none");

  },

  hasSizeChart: function() {
    return $(this.data.selectors.container).length > 0;
  }

}


export default SizeChartSocks;